import jQuery from 'jquery';

import config from 'src/config';
import SEGMENT_EVENTS from 'constants/segmentEvents';
import authHelper from 'src/api/auth/helper';

function RootScopeGlobals($rootScope, $state, $stateParams, $location, tlSettingsService, regexService, tlQuery,
  partnerService, tlUserService, utilsService, tlAuthService, imgixService, jsSdkAuthService, tlTrackService,
  jsSdkConfig, jsSdkKeychain, tlKeychain, jsSdkUserService, tlEventEmitter, trackingService, fraudService) {
  // Fix dropdown and dropdown-toggle menus on Mobile Devices.
  // Currently being used on the event-based variation of home page.
  jQuery('body').on('touchstart.dropdown', '.dropdown-menu', function(e) {
    e.stopPropagation();
  });

  jsSdkSync();

  tlEventEmitter.on(tlUserService.EVENTS().USER_UPDATED, function() {
    jsSdkSync();

    $rootScope.currentUser = tlUserService.currentUser();

    if ($rootScope.currentUser && utilsService.isNewUser($rootScope.currentUser)) {
      trackingService.trackEvent(SEGMENT_EVENTS.SignedUp);
    }

    fraudService.setUser($rootScope.currentUser);
  });

  if ($rootScope.affiliateId) {
    tlTrackService.setAffiliate($rootScope.affiliateId);
  }

  jsSdkConfig.setApiKey(config.TL_API_KEY);

  if (tlQuery.get('attributionId')) {
    jsSdkConfig.setAttributionId(tlQuery.get('attributionId'));
  }

  if (tlQuery.get('attributionType')) {
    jsSdkConfig.setAttributionType(tlQuery.get('attributionType'));
  }

  if (tlQuery.get('auth')) {
    const auth = tlQuery.get('auth');

    authHelper.setAuthToken(auth);

    jsSdkKeychain.setConsumerAuthToken(auth);
    tlKeychain.setAuthToken(auth);
  } else if (tlQuery.get('prospect')) {
    const prospect = tlQuery.get('prospect');

    authHelper.setProspectToken(prospect);

    jsSdkKeychain.setPropsectToken(prospect);
    tlKeychain.setProspectToken(prospect);
  }

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.currentDate = new Date();
  $rootScope.config = tlSettingsService.config();
  $rootScope.regexes = regexService;
  $rootScope.fullpage = $location.search() ? $location.search().fullpage === 'true' : false;
  $rootScope.affiliateId = tlQuery.get('affiliateId') || tlQuery.get('affiliate') || null;
  $rootScope.trackingId = tlQuery.get('trackingId') || tlQuery.get('tracking') || null;
  $rootScope.partner = partnerService.partner;
  $rootScope.browseVenues = function() {
    $state.go('app.browse.venues', {
      city: utilsService.defaultCitySlug()
    });
  };
  $rootScope.browseCity = function() {
    $state.go('app.browse.city', {
      city: utilsService.defaultCitySlug()
    });
  };
  $rootScope.showConcierge = function() {
    return partnerService.partner && partnerService.partner.default;
  };
  $rootScope.currentUserImageUrl = function(size) {
    if (!$rootScope.currentUser || !$rootScope.currentUser.imageUrl) return null;

    return imgixService.url($rootScope.currentUser.imageUrl, {
      width: size || 100,
      height: size || 100
    });
  };
  $rootScope.isLoggedIn = function() {
    return jsSdkAuthService.isLoggedIn();
  };
  $rootScope.logout = function() {
    jsSdkAuthService.logout();
    tlAuthService.logout();
    authHelper.removeAuthToken();

    $rootScope.$broadcast('logout');

    $state.go('app.home');
  };

  function jsSdkSync() {
    const authToken = tlAuthService.authToken();
    const prospectToken = tlKeychain.prospectToken();
    const user = tlUserService.currentUser();

    if (authToken) {
      jsSdkKeychain.setConsumerAuthToken(authToken);
    }

    if (prospectToken) {
      jsSdkKeychain.setPropsectToken(prospectToken);
    } else {
      jsSdkKeychain.removeProspectToken();
    }

    if (user) {
      jsSdkUserService.setCurrentUser(user);
    } else {
      jsSdkUserService.removeCurrentUser();
    }
  }
}

RootScopeGlobals.$inject = [
  '$rootScope',
  '$state',
  '$stateParams',
  '$location',
  'tl.settings.service',
  'regexService',
  'tl.query',
  'partnerService',
  'tl.user.service',
  'utilsService',
  'tl.auth.service',
  'jsSdk.imgix',
  'jsSdk.auth',
  'tl.track.service',
  'jsSdk.config',
  'jsSdk.keychain',
  'tl.keychain',
  'jsSdk.user',
  'tl.ee',
  'trackingService',
  'fraudService'
];

export default RootScopeGlobals;



// WEBPACK FOOTER //
// ./src/rootScopeGlobals.js